<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9fDCAP/cover.jpeg?1684514748274" alt="This image is the cover for the book The Unparalleled Farmer Girl, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Unparalleled Farmer Girl, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p>In the 21st century, Bai Yixuan had risked her own life to save someone. She had traveled all the way to the body of a poor girl who had been annulled in ancient times.The Dual Healing Medicine slowly became a famous genius doctor in the distant and near future. It would open up heaven's space, help her clear all obstacles, and lead her relatives and friends to become well-off …</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yan YangTian, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18d6264c